// extracted by mini-css-extract-plugin
export default {"support":"index_support_4nUCN"};